import React from 'react'
import { string, shape, node, bool } from 'prop-types'
import classNames from 'classnames'
import ThemeConsumer from '../ThemeConsumer'


const Toolbar = ({
  theme,
  children,
  contextual,
}) => {
  const classes = classNames(
    theme.toolbar,
    { [theme.contextual]: contextual }
  )

  return (
    <div className={classes}>
      <div className={theme.inner}>
        {children}
      </div>
    </div>
  )
}

Toolbar.propTypes = {
  children: node,
  contextual: bool,

  theme: shape({
    toolbar: string,
    inner: string,
  }),
}

Toolbar.defaultProps = {
  children: null,
  theme: {},
  contextual: false,
}

export default ThemeConsumer('UIToolbar')(Toolbar)



// WEBPACK FOOTER //
// ./src/shared/components/Toolbar/index.js